import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import ReactTextareaAutosize from 'react-textarea-autosize';

const Textarea = React.forwardRef((props, ref) => {
  return <StyledTextarea ref={ref} {...props} />;
});

Textarea.propTypes = {
  autoFocus: PropTypes.bool,
  value: PropTypes.string,
};

const errorCss = css`
  border-color: ${p => p.theme.colors.red400};
  &:focus {
    border-color: ${p => p.theme.colors.red600};
  }
`;

const StyledTextarea = styled(({ isError, maxLength, ...rest }) => (
  <ReactTextareaAutosize maxLength={maxLength} {...rest} />
))`
  background-color: ${p => p.theme.colors.white};
  border: 1px solid ${p => p.theme.colors.gray300};
  padding: 8px;
  border-radius: 4px;
  width: 100%;
  min-height: 100px;
  resize: none;
  &:focus {
    border-color: ${p => p.theme.colors.gray600};
  }
  transition: border-color 100ms ease-in;
  &[disabled] {
    background-color: ${p => p.theme.colors.gray100};
    color: ${p => p.theme.colors.gray500};
  }
  ${p => p.isError && errorCss};
`;

export default Textarea;
